import Container from  './Container';

export default Container;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Container/index.ts